<nav class="tab-container">
    <div>
      <button class="button" [ngClass]="{ 'active': currentTab === 'General', 'inactive': currentTab !== 'General' }" (click)="setTab('General')">
        General
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Accounts', 'inactive': currentTab !== 'Accounts' }" (click)="setTab('Accounts')">
        Accounts
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Appearance', 'inactive': currentTab !== 'Appearance' }" (click)="setTab('Appearance')">
        Appearance
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Accessibility', 'inactive': currentTab !== 'Accessibility' }" (click)="setTab('Accessibility')">
        Accessibility
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Security', 'inactive': currentTab !== 'Security' }" (click)="setTab('Security')">
        Security
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Support & Feedback', 'inactive': currentTab !== 'Support & Feedback' }" (click)="setTab('Support & Feedback')">
        Support & Feedback
      </button>
     
    </div>
  </nav>
  
  <div class="tab-view" [ngClass]="{ 'active': currentTab === 'your_active_tab' }">
    <!-- Content for the active tab goes here -->
  </div>
  